//@flow
import React from 'react';
import { words } from 'lodash';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import classNames from 'classnames';
import { Image } from 'components/atoms/image';
import { ActionButton } from 'components/atoms/button';
import { HTMLView } from 'components/atoms/htmlView';
import { StringUtil } from 'utils/StringUtil';
import IconCoralRight from 'assets/images/RIGHT.png';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  heading: string,
  first_content: string,
  second_content: string,
  onClick?: void,
  sectionImage: string,
  buttonName?: string,
  containerClassName: string,
  tagWord: string,
  onGetInTouchClick: () => void,
  thumbNailUrl?: string,
};

const ImageInfoModule = (props: Props) => {
  const {
    heading,
    first_content,
    second_content,
    onClick,
    sectionImage,
    buttonName,
    containerClassName,
    tagWord,
    thumbNailUrl,
  } = props;

  const { height } = useViewport();

  const containerClassNames = classNames(
    'section-container',
    'image-info-module',
    containerClassName
  );

  const onGetInTouchClick = () => {
    props.onGetInTouchClick && props.onGetInTouchClick();
  };

  let countLength = words(tagWord).length;
  let checkTagWord =
    countLength > 10
      ? `${StringUtil.formatDescription(tagWord, 10)}...`
      : tagWord;

  return (
    <div className={containerClassNames} style={{ height }}>
      <div className="inner-section">
        <Row className="page-text">
          <Col md={{ span: 3 }}>
            <h1 className="heading-col">{heading}</h1>
            <h4 className="tag-word">{checkTagWord}</h4>
          </Col>
          <Col md={{ span: 3, offset: 1 }}>
            <HTMLView
              tagName={'p'}
              html={first_content}
              className={'first-content'}
            />
          </Col>
          <Col md={{ span: 3, offset: 1 }}>
            <HTMLView
              tagName={'p'}
              html={second_content}
              className={'second-content'}
            />
            {buttonName && (
              <ActionButton
                className="explore-module"
                buttonName={buttonName}
                onClick={onClick}
                iconRight={IconCoralRight}
              />
            )}
          </Col>
        </Row>
        <Row className="image-row">
          <Col className="image-col" md={{ span: 11 }}>
            <div className="image-div">
              <Image thumbNail={thumbNailUrl} src={sectionImage} alt="media" />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ImageInfoModule;
